
        import Symbol from "../../../svg-baker-runtime/browser-symbol.js";
        import sprite from "../../../svg-sprite-loader/runtime/browser-sprite.build.js";

        const symbol = new Symbol({
  "id": "icon-material-preview",
  "use": "icon-material-preview-usage",
  "viewBox": "0 -960 960 960",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 -960 960 960\" id=\"icon-material-preview\"><path d=\"M182.63-114.5q-28.1 0-48.12-20.01-20.01-20.02-20.01-48.12v-594.74q0-28.1 20.01-48.12 20.02-20.01 48.12-20.01h594.74q28.1 0 48.12 20.01 20.01 20.02 20.01 48.12v594.74q0 28.1-20.01 48.12-20.02 20.01-48.12 20.01zM180-180h600v-520H180zm300.04-105Q400-285 337-328.15t-92-112Q274-509 336.96-552t143-43T623-551.85t92 112Q686-371 623.04-328t-143 43m-.04-50q57 0 104.95-27.83Q632.9-390.65 660-440q-27.1-49.35-75.05-77.17Q537-545 480-545t-104.95 27.83Q327.1-489.35 300-440q27.1 49.35 75.05 77.17Q423-335 480-335m.12-55q20.88 0 35.38-14.62t14.5-35.5-14.62-35.38-35.5-14.5-35.38 14.62-14.5 35.5 14.62 35.38 35.5 14.5\" /></symbol>"
});
        sprite.add(symbol);

        function Icon({...props}) {
            return (
                <svg {...props} className="icon" fill="currentColor">
                    <use xlinkHref="#icon-material-preview"/>
                </svg>
            );
        };

        Icon.id = "icon-material-preview";

        export default Icon;
    